/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Visibility = exports.ViewAs = exports.Type = exports.SortOrder = exports.SimpleMessageType = exports.Orientation = exports.OfflineChannelId = exports.NotificationChannels = exports.MessageVisibility = exports.MessageType = exports.MessageDirection = exports.GetMessagesOrder = exports.ChatActionTypes = exports.ButtonType = exports.BadgeVisibility = void 0;
var BadgeVisibility;
(function (BadgeVisibility) {
    BadgeVisibility["UNKNOWN"] = "UNKNOWN";
    BadgeVisibility["EVERYONE"] = "EVERYONE";
    BadgeVisibility["BUSINESS"] = "BUSINESS";
})(BadgeVisibility = exports.BadgeVisibility || (exports.BadgeVisibility = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["ACTION"] = "ACTION";
    ButtonType["POSTBACK"] = "POSTBACK";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var ChatActionTypes;
(function (ChatActionTypes) {
    ChatActionTypes["BUTTON_INTERACTION"] = "BUTTON_INTERACTION";
})(ChatActionTypes = exports.ChatActionTypes || (exports.ChatActionTypes = {}));
var GetMessagesOrder;
(function (GetMessagesOrder) {
    GetMessagesOrder["UNKNOWN"] = "UNKNOWN";
    GetMessagesOrder["ASC"] = "ASC";
    GetMessagesOrder["DESC"] = "DESC";
})(GetMessagesOrder = exports.GetMessagesOrder || (exports.GetMessagesOrder = {}));
var MessageDirection;
(function (MessageDirection) {
    MessageDirection["BUSINESS_TO_VISITOR"] = "BUSINESS_TO_VISITOR";
    MessageDirection["VISITOR_TO_BUSINESS"] = "VISITOR_TO_BUSINESS";
})(MessageDirection = exports.MessageDirection || (exports.MessageDirection = {}));
var MessageType;
(function (MessageType) {
    MessageType["PLAIN"] = "PLAIN";
    MessageType["TEMPLATE"] = "TEMPLATE";
    MessageType["MINIMAL"] = "MINIMAL";
    MessageType["FORM"] = "FORM";
    MessageType["CUSTOM"] = "CUSTOM";
    MessageType["SYSTEM"] = "SYSTEM";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var MessageVisibility;
(function (MessageVisibility) {
    MessageVisibility["EVERYONE"] = "EVERYONE";
    MessageVisibility["BUSINESS"] = "BUSINESS";
})(MessageVisibility = exports.MessageVisibility || (exports.MessageVisibility = {}));
var NotificationChannels;
(function (NotificationChannels) {
    NotificationChannels["UNKNOWN"] = "UNKNOWN";
    NotificationChannels["ALL"] = "ALL";
    NotificationChannels["NONE"] = "NONE";
})(NotificationChannels = exports.NotificationChannels || (exports.NotificationChannels = {}));
var OfflineChannelId;
(function (OfflineChannelId) {
    OfflineChannelId["EMAIL"] = "EMAIL";
    OfflineChannelId["FACEBOOK"] = "FACEBOOK";
    OfflineChannelId["SMS"] = "SMS";
    OfflineChannelId["WHATSAPP"] = "WHATSAPP";
    OfflineChannelId["PHONE"] = "PHONE";
})(OfflineChannelId = exports.OfflineChannelId || (exports.OfflineChannelId = {}));
var Orientation;
(function (Orientation) {
    Orientation["PORTRAIT"] = "PORTRAIT";
    Orientation["LANDSCAPE"] = "LANDSCAPE";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
var SimpleMessageType;
(function (SimpleMessageType) {
    SimpleMessageType["TEXT"] = "TEXT";
    SimpleMessageType["IMAGE"] = "IMAGE";
    SimpleMessageType["FILE"] = "FILE";
})(SimpleMessageType = exports.SimpleMessageType || (exports.SimpleMessageType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Type;
(function (Type) {
    Type["PARTICIPANT_JOINED"] = "PARTICIPANT_JOINED";
    Type["PARTICIPANT_LEFT"] = "PARTICIPANT_LEFT";
    Type["DESCRIPTION_CHANGED"] = "DESCRIPTION_CHANGED";
})(Type = exports.Type || (exports.Type = {}));
var ViewAs;
(function (ViewAs) {
    ViewAs["UNDEFINED"] = "UNDEFINED";
    ViewAs["VISITOR"] = "VISITOR";
    ViewAs["BUSINESS"] = "BUSINESS";
})(ViewAs = exports.ViewAs || (exports.ViewAs = {}));
var Visibility;
(function (Visibility) {
    Visibility["EVERYONE"] = "EVERYONE";
    Visibility["PRIVILEGED"] = "PRIVILEGED";
})(Visibility = exports.Visibility || (exports.Visibility = {}));
//# sourceMappingURL=types.js.map